import { create } from 'zustand';

export const useAuthStore = create((set, ) => ({
  isAuthenticated: false,
  admin: {},
  loading: true,
  setAdmin: (value) => set({ admin: value }),
  setAuthenticated: (value) => set({ isAuthenticated: value }),
  setLoading: (value) => set({ loading: value }),
}));


export const editPopupStore = create((set, get) => ({ 
  editData: {
  },

  updateData: {
  },

  delGalleryImages: [],

  clearData: () => {
    set({
      updateData: {},
      editData:{},
      delGalleryImages: []
    })
  },

  setEditData: (data) => {
    const decodeHtml = (html) => {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    };

    set({
      editData: {
        ...data,
        ...(data.hasOwnProperty("jobDescription") && {
          jobDescription: decodeHtml(data.jobDescription || "")
        }),
        ...(data.hasOwnProperty("whyChooseUs") && {
          whyChooseUs: decodeHtml(data.whyChooseUs || "")
        })
      }
    });
  },

  handleEditChange: (e, name) => {
    let value;
    if (typeof e === "string" && name) {
      value = e;
    } else {
      value = e.target.value;
      name = e.target.name;
    }

    const currentData = get().editData;
    set({ editData: { ...currentData, [name]: value } });
  },

  handleEditChangeWithImage: (e) => {
    const { name, value, files } = e.target;
    const newValue =  files ? (files && files[0] ? files[0] : "") : value;
    const currentData = get().editData;
    const currentUpdateData = get().updateData;
    set({ editData: { ...currentData, [name]: newValue }});
    set({ updateData: { ...currentUpdateData, [name]: newValue }});
  },


  handleRemoveImage: (name) => {
    const currentData = get().editData;
    set({editData: {...currentData, [name]: ""}})
  },

  handleChange: (data, key) => {
    const currentEmployees = get().editData;
    const currentUpdateData = get().updateData;
    set({editData: {...currentEmployees, [key]: data}})
     set({ updateData: { ...currentUpdateData, [key]: data }});
  },

  handleDelChange: (data) => {
    const currentUpdateData = get().delGalleryImages || [];
    set({
        delGalleryImages: [...currentUpdateData, data],
      });
  }
  }))

export const useJob = create((set)=> ({
  allJobs: [],
  loading: true,
  selectedJob: "",
  setSelectedJob: (id)=>set({selectedJob: id}),
  setAllJobs: (data) => set({allJobs: data})
}))

export const usePostBlog = create((set)=>({
  allBlogs: [],
  setAllBlogs: (data) => set({allBlogs: data}),
  multiplePreview: [],
  setMultiplePreview: (data)=> set({multiplePreview: data}),
  singlePreview: "",
  eSinglePreview: "",
  setSinglePreview: (data)=> set({singlePreview: data}),
  esetSinglePreview: (data)=> set({eSinglePreview: data}),
}))

  export const Tablectrl = create((set) => ({
  success: false,
  setSuccessTrue: () => set({ success: true }),
  setSuccessFalse: () => set({ success: false })
}));

export const useBlogs = create((set)=> ({
  allBlogs: [],
  loading: true,
  selectedBlog: "",
  setSelectedBlog: (id)=>set({selectedBlog: id}),
  setAllBlogs: (data) => set({allBlogs: data})
}))














// setMultiplePreview: (updater) =>
//   set((state) => ({
//     multiplePreview:
//       typeof updater === 'function' ? updater(state.multiplePreview) : updater,
//   })),

  // handleRemoveImage: (formData,setFormData) => setFormData({...formData, image: ""}) 